import { render, staticRenderFns } from "./DoctorTable.vue?vue&type=template&id=3ec5ab4f&scoped=true"
import script from "./DoctorTable.vue?vue&type=script&lang=js"
export * from "./DoctorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec5ab4f",
  null
  
)

export default component.exports